import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/WaterwayTypes/Get`, payload),
    GetSize: (payload) => Repository.post(`/api/WaterwayTypes/GetSize`, payload),
    GetActive: (payload) => Repository.post(`/api/WaterwayTypes/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/WaterwayTypes/GetById`, payload),
    Add: (payload) => Repository.post(`/api/WaterwayTypes/Add`, payload),
    Edit: (payload) => Repository.post(`/api/WaterwayTypes/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/WaterwayTypes/Edit`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/WaterwayTypes/ChangeStatus`, payload),
}
